/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateAccountResult } from '../../models/create-account-result';
import { CreateMultipleAccountsDto } from '../../models/create-multiple-accounts-dto';

export interface AccountControllerCreateMultipleAccounts$Params {
      body: CreateMultipleAccountsDto
}

export function accountControllerCreateMultipleAccounts(http: HttpClient, rootUrl: string, params: AccountControllerCreateMultipleAccounts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CreateAccountResult>>> {
  const rb = new RequestBuilder(rootUrl, accountControllerCreateMultipleAccounts.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CreateAccountResult>>;
    })
  );
}

accountControllerCreateMultipleAccounts.PATH = '/account/create-multiple';
